export default class Form {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".umbraco-forms-form");
		this.inputFieldsList = this.el.querySelectorAll(".input-simple");
		this.inputTextarea = this.el.querySelectorAll(".textarea-simple");
		this.fieldsThatNeedLabel = this.el.querySelectorAll("input, select");
		this.checkboxLists = this.el.querySelectorAll(".checkboxlist");
		this.radioLists = this.el.querySelectorAll(".radiobuttonlist");

		this.labelActiveClass = "umbraco-forms-label--active";
		this.inputHasLabelClass = "input-simple--has-label";

		this.inputErrorValidationClass = "input-validation-error";
		this.errorValidationClass = "co-validmark--not-valid";

		this.inputValidValidationClass = "input-validation-valid";
		this.validValidationClass = "co-validmark--valid";

		this.init();
	}

	init() {
		this.setAccessibility();
		this.attachEvents();
	}
	attachEvents() {
		let self = this;

		//inputs(short answer fields)
		this.inputFieldsList.forEach((el) => {
			this.setLabelText(el);

			//focus
			el.addEventListener(
				"focus",
				(e) => {
					self.setLabelActiveClass(e.target);
				},
				true
			);

			//blur
			el.addEventListener(
				"blur",
				(e) => {
					self.removeLabelActiveClass(e.target);
				},
				true
			);

			el.addEventListener(
				"input",
				(e) => {
					setTimeout(() => {
						//error
						this.setValidationClass(
							e.target,
							this.inputErrorValidationClass,
							this.errorValidationClass
						);

						//valid
						this.setValidationClass(
							e.target,
							this.inputValidValidationClass,
							this.validValidationClass
						);
					}, 500);
				},
				true
			);
		});

		//textarea
		this.inputTextarea.forEach((el) => {
			this.setLabelText(el);

			//focus
			el.addEventListener(
				"focus",
				(e) => {
					self.setLabelActiveClass(e.target);
				},
				true
			);

			//blur
			el.addEventListener(
				"blur",
				(e) => {
					self.removeLabelActiveClass(e.target);
				},
				true
			);
		});
	}

	setLabelText(el) {
		let placeholderElm = el.getAttribute("placeholder");
		let formEle = el.closest(".umbraco-forms-field");
		let labelEle = formEle.querySelector(".umbraco-forms-label");

		//Set label with placeholder value if has been provided
		if (placeholderElm != null) {
			labelEle.textContent = placeholderElm;
		}
	}

	setValidationClass(elem, hasClass, vClass) {
		if (elem.classList.contains(hasClass)) {
			elem.closest(".co-validmark").classList.add(vClass);
		} else {
			elem.closest(".co-validmark").classList.remove(vClass);
		}
	}

	setLabelActiveClass(el) {
		let self = this;
		let formEle = el.closest(".umbraco-forms-field");
		let labelEle = formEle.querySelector(".umbraco-forms-label");

		if (labelEle != null) {
			labelEle.classList.add(self.labelActiveClass);
			el.classList.add(self.inputHasLabelClass);
		}
	}

	removeLabelActiveClass(el) {
		let self = this;
		let formEle = el.closest(".umbraco-forms-field");
		let labelEle = formEle.querySelector(".umbraco-forms-label");

		if (labelEle != null && el.value == "") {
			labelEle.classList.remove(self.labelActiveClass);
			el.classList.remove(self.inputHasLabelClass);
		}
	}

	setAccessibility() {
		//Set aria-label on input fields if they don't have one - This is to optimize Umbraco Forms accessibility
		this.fieldsThatNeedLabel.forEach(function (el) {
			var self = this;

			if (!el.hasAttribute("aria-label")) {
				let parentElem =
					el.closest(".umbraco-forms-field") != null
						? el.closest(".umbraco-forms-field")
						: null;
				if (parentElem != null) {
					let elemLabel =
						parentElem.querySelector(".umbraco-forms-label") != null
							? parentElem.querySelector(".umbraco-forms-label")
							: "";

					let elemHelpText =
						parentElem.querySelector(".umbraco-forms-tooltip") !=
						null
							? parentElem.querySelector(".umbraco-forms-tooltip")
							: "";

					//Use help text instead of label if has been provided.
					if (elemHelpText != "") {
						el.setAttribute(
							"aria-label",
							elemHelpText.dataset.value
						);
					} else {
						if (elemLabel != "") {
							el.setAttribute(
								"aria-label",
								elemLabel.dataset.value
							);
						}
					}
				}
			}
		});

		const getListLabel = (el, fallback) => {
			const wrapper = el.closest(".umbraco-forms-field");
			let ariaLabel = fallback;
			if (wrapper) {
				const label = wrapper.querySelector(".umbraco-forms-label");
				if (label && label.textContent) {
					ariaLabel = label.textContent;
				}
			}
			return ariaLabel;
		};

		//Add group and label to check box lists
		this.checkboxLists.forEach(function (el) {
			if (!el.hasAttribute("role")) {
				el.setAttribute("role", "group");
				el.setAttribute(
					"aria-label",
					getListLabel(el, "Check box list")
				);
			}
		});

		//Add group and label to radiobutton lists
		this.radioLists.forEach(function (el) {
			if (!el.hasAttribute("role")) {
				el.setAttribute("role", "radiogroup");

				el.setAttribute(
					"aria-label",
					getListLabel(el, "Radio button list")
				);
			}
		});
	}
}
